module.exports = __webpack_public_path__ + "img/volume_down.b491e3c2.svg";